'use strict';
{
    var app = angular.module('tf.hedgeHelper', [])
        .controller('hedgeHelperCtrl', ['$scope', '$state',  '$resource', 'uiGridConstants', 'uiGridExporterConstants', '$http', 'csv', '$sanitize', '$aside', function hedgeHelperController($scope, $state, $resource, uiGridConstants, uiGridExporterConstants, $http, csv, $sanitize, $aside) {

            $scope.oneAtATime = true;

            $scope.pricePopover = {
                templateUrl: 'app/hedgeHelper/pricePopover.tpl.html'
            };



        }]);
}